"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONBOARDING_SET_ID = void 0;
exports.ONBOARDING_SET_ID = 10000;
//# sourceMappingURL=base_vocab_sets.js.map